/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Adjustment_CreatedInputs */

const en_shipping_adjustment_created = /** @type {(inputs: Shipping_Adjustment_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping adjustment created`)
};

const es_shipping_adjustment_created = /** @type {(inputs: Shipping_Adjustment_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste de envio creado`)
};

/**
* | output |
* | --- |
* | "Shipping adjustment created" |
*
* @param {Shipping_Adjustment_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const shipping_adjustment_created = /** @type {((inputs?: Shipping_Adjustment_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Adjustment_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_adjustment_created(inputs)
	return es_shipping_adjustment_created(inputs)
});